/**
 * This is the root of all the components/containers of the app. This is also where containers
 * that are not routed should be placed.
 * @ngesdoc component
 * @ngname rootContainer
 * @ngcontainer
 * @ngmodule root
 */
export default {
  template: `
    <app-container>
      <uimessages-container></uimessages-container>
      <router-container></router-container>
    </app-container>
  `,
};
